import React, { useState, useEffect, useContext } from 'react';
import { apiRequest } from '../api';
import { AuthContext } from '../context/AuthContext';
import './AffiliateProgram.css';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../apiConfig';
import arrowIcon from '../assets/icons/arrow-icon.png';
import { useTranslation } from 'react-i18next';

const AffiliateProgramForm = ({ isTelegramMiniApp }) => {
  const { user } = useContext(AuthContext);
  const [channelName, setChannelName] = useState('');
  const [email, setEmail] = useState('');
  const [additionalNotes, setAdditionalNotes] = useState('');
  const [message, setMessage] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation('affiliate');

  const escapeHTML = (input) => {
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;',
    };
    return input.replace(/[&<>"']/g, (char) => map[char]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsProcessing(true);

    try {
      const sanitizedChannelName = escapeHTML(channelName);
      const sanitizedEmail = escapeHTML(email);
      const sanitizedAdditionalNotes = escapeHTML(additionalNotes);

      const response = await apiRequest(
        `${API_BASE_URL}/api/affiliate-program/request`,
        {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            channelName: sanitizedChannelName,
            email: sanitizedEmail,
            additionalNotes: sanitizedAdditionalNotes,
          }),
        }
      );

      const data = await response.json();
      if (response.ok) {
        setMessage(t('messages.success'));
      } else {
        setMessage(data.message || t('messages.fail'));
      }
    } catch (error) {
      setMessage(t('messages.error'));
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className={`affiliate-page-container`}>
      <div className="affiliate-page-header">
        {!isTelegramMiniApp && (
          <button
            onClick={() => navigate(-1)}
            className="affiliate-back-button"
          >
            <img
              src={arrowIcon}
              alt="Back"
              className="affiliate-back-icon"
            />
          </button>
        )}
        <h2 className="affiliate-page-title">{t('title')}</h2>
      </div>

      <p className="affiliate-description">{t('description')}</p>

      <form onSubmit={handleSubmit} className="affiliate-form">
        <div className="affiliate-form-group">
          <label className="affiliate-label">{t('fields.channel_name')}</label>
          <div className="base-item-box affiliate-input-box">
            <input
              type="text"
              value={channelName}
              onChange={(e) => setChannelName(e.target.value)}
              required
              className="affiliate-input"
              placeholder={t('placeholders.enter')}
              autoComplete="off"
              spellCheck={false}
              name="some-channel"
            />
          </div>
        </div>

        <div className="affiliate-form-group">
          <label className="affiliate-label">{t('fields.email')}</label>
          <div className="base-item-box affiliate-input-box">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="affiliate-input"
              placeholder={t('placeholders.enter')}
              autoComplete="off"
            />
          </div>
        </div>

        <div className="affiliate-form-group">
          <label className="affiliate-label">{t('fields.notes')}</label>
          <div className="base-item-box affiliate-input-box">
            <input
              type="text"
              value={additionalNotes}
              onChange={(e) => setAdditionalNotes(e.target.value)}
              className="affiliate-input"
              placeholder={t('placeholders.enter')}
              autoComplete="off"
              spellCheck={false}
              name="some-notes"
            />
          </div>
        </div>

        {message && <p className="affiliate-message">{message}</p>}

        <button
          type="submit"
          className="base-item-box affiliate-submit-button"
          disabled={isProcessing}
        >
          <span className="base-item-content affilate-submit">
            {isProcessing ? (
              <>
                <span className="affiliate-spinner"></span>{' '}
                {t('buttons.submitting')}
              </>
            ) : (
              t('buttons.submit')
            )}
          </span>
        </button>
      </form>
    </div>
  );
};

export default AffiliateProgramForm;
